import { avatarColors } from "../../utils/constants/avatarColors";
import { AvatarConfig, AvatarStyles } from "./types";

const hashString = (str: string): number => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return Math.abs(hash);
};

const processText = (text?: string, maxChars: number = 1): string => {
  if (!text) return "A";

  const cleanText = text.trim().toUpperCase();

  if (cleanText.length <= maxChars) return cleanText;

  if (cleanText.includes(" ")) {
    return cleanText
      .split(" ")
      .map((word) => word[0])
      .join("")
      .slice(0, maxChars);
  }

  return cleanText.slice(0, maxChars);
};

const generateAvatar = (
  config: AvatarConfig
): { styles: AvatarStyles; text: string } => {
  const { text, maxChars = 1, size = 24 } = config;

  const processedText = processText(text, maxChars);

  const hash = hashString(processedText);
  const colorIndex = hash % avatarColors.length;
  const colors = avatarColors[colorIndex];

  const styles: AvatarStyles = {
    backgroundColor: colors.backgroundColor,
    border: `1px solid ${colors.borderColor}`,
    color: colors.textColor,
    width: `${size}px`,
    height: `${size}px`,
  };
  return {
    styles,
    text: processedText,
  };
};

export const Avatar: React.FC<AvatarConfig> = (props) => {
  const { styles, text = "" } = generateAvatar(props);
  const { className = "" } = props;

  return (
    <div
      className={`shrink-0 rounded-full flex flex-col items-center justify-center text-sm font-medium ${className}`}
      style={styles}
    >
      <p>{text}</p>
    </div>
  );
};
